<template>
    <div>
        <div id='travellerSection'>
            <div id='traveller1'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 1 ({{$t("text.applicant")}})</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                          <label for='traveller1_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                          <datepicker id='traveller1_dob' 
                              v-model='traveller1_dob'
                              initial-view="year" 
                              :openDate="openBirthDates"
                              :disabledDates="disabledBirthDates" 
                              :typeable=true
                              :language='datePickerLanguageLookup()'
                              input-class='form-control' 
                              :placeholder='$t("text.datePlaceholder")'
                              format='M/d/yyyy'
                              aria-required='true'></datepicker>
                          <div class='form-row' style=''>
                            <div class='col-auto'>
                              <input @change='swapPrimaryApplicant' type='checkbox' class='regular-checkbox' id='isPrimaryApplicant' name='isNotPrimaryApplicant' style='margin-top:20px;'/>
                            </div>
                            <div class='col'>
                              <label for='isPrimaryApplicant' id='lbl_isPrimaryApplicant' class='checkbox-label' style='color: #666666; margin-top:20px;'>Primary applicant</label>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                            <span for='traveller1_dob' class='feedback' id='err_traveller1_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>
 
            <div id='traveller2'>
            <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 2</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                          <label for='traveller2_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                          <datepicker id='traveller2_dob' 
                              v-model='traveller2_dob'
                              initial-view="year" 
                              :openDate="openBirthDates"
                              :disabledDates="disabledBirthDates" 
                              :typeable=true
                              :language='datePickerLanguageLookup()'
                              input-class='form-control' 
                              :placeholder='$t("text.datePlaceholder")'
                              format='M/d/yyyy'
                              aria-required='true'></datepicker>  
                            <div class='form-row' style=''>
                              <div class='col-auto'>
                                <input @change='swapPrimaryApplicant' type='checkbox' class='regular-checkbox' id='isNotPrimaryApplicant' name='isNotPrimaryApplicant' style='margin-top:20px;'/>
                              </div>
                              <div class='col'>
                                <label for='isNotPrimaryApplicant' id='lbl_isNotPrimaryApplicant' class='checkbox-label' style='color: #666666; margin-top:20px;'>Primary applicant</label>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                            <span for='traveller2_dob' class='feedback' id='err_traveller2_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller3'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 3</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller3_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller3_dob' 
                            v-model='traveller3_dob'
                            initial-view="year" 
                            :openDate="openBirthDates"
                            :disabledDates="disabledBirthDates" 
                            :typeable=true
                            :language='datePickerLanguageLookup()'
                            input-class='form-control' 
                            :placeholder='$t("text.datePlaceholder")' 
                            format='M/d/yyyy'
                            aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller3_dob' class='feedback' id='err_traveller3_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller4'>
                <fieldset>
                <legend class='textTraveller'>{{$t("text.traveller")}} # 4</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller4_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller4_dob' 
                            v-model='traveller4_dob'
                            initial-view="year" 
                            :openDate="openBirthDates"
                            :disabledDates="disabledBirthDates" 
                            :typeable=true
                            :language='datePickerLanguageLookup()'
                            input-class='form-control' 
                            :placeholder='$t("text.datePlaceholder")'
                            format='M/d/yyyy'
                            aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller4_dob' class='feedback' id='err_traveller4_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller5'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 5</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller5_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller5_dob' 
                            v-model='traveller5_dob'
                            initial-view="year" 
                            :openDate="openBirthDates"
                            :disabledDates="disabledBirthDates" 
                            :typeable=true
                            :language='datePickerLanguageLookup()'
                            input-class='form-control' 
                            :placeholder='$t("text.datePlaceholder")'
                            format='M/d/yyyy'
                            aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller5_dob' class='feedback' id='err_traveller5_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller6'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 6</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller6_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller6_dob' 
                            v-model='traveller6_dob'
                            initial-view="year" 
                            :openDate="openBirthDates"
                            :disabledDates="disabledBirthDates" 
                            :typeable=true
                            :language='datePickerLanguageLookup()'
                            input-class='form-control' 
                            :placeholder='$t("text.datePlaceholder")'
                            format='M/d/yyyy'
                            aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller6_dob' class='feedback' id='err_traveller6_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller7'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 7</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller7_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller7_dob' 
                            v-model='traveller7_dob'
                            initial-view="year" 
                            :openDate="openBirthDates"
                            :disabledDates="disabledBirthDates" 
                            :typeable=true
                            :language='datePickerLanguageLookup()'
                            input-class='form-control' 
                            :placeholder='$t("text.datePlaceholder")'
                            format='M/d/yyyy'
                            aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller7_dob' class='feedback' id='err_traveller7_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller8'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 8</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller8_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller8_dob' 
                            v-model='traveller8_dob'
                            initial-view="year" 
                            :openDate="openBirthDates"
                            :disabledDates="disabledBirthDates" 
                            :typeable=true
                            :language='datePickerLanguageLookup()'
                            input-class='form-control' 
                            :placeholder='$t("text.datePlaceholder")'
                            format='M/d/yyyy'
                            aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller8_dob' class='feedback' id='err_traveller8_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller9'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 9</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                        <label for='traveller9_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                        <datepicker id='traveller9_dob' 
                            v-model='traveller9_dob'
                            initial-view="year" 
                            :openDate="openBirthDates"
                            :disabledDates="disabledBirthDates" 
                            :typeable=true
                            :language='datePickerLanguageLookup()'
                            input-class='form-control' 
                            :placeholder='$t("text.datePlaceholder")'
                            format='M/d/yyyy'
                            aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller9_dob' class='feedback' id='err_traveller9_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div id='traveller10'>
                <fieldset>
                    <legend class='textTraveller'>{{$t("text.traveller")}} # 10</legend>
                    <div class='form-group row' >
                        <div class='col-12'>
                            <label for='traveller10_dob' v-html='$t("text.dateofbirth")+"<span class=\"requiredText\" aria-hidden=\"true\">*</span><br/>"+$t("text.dateofbirthformat")'></label>
                            <datepicker id='traveller10_dob' 
                                v-model='traveller10_dob'
                                initial-view="year" 
                                :openDate="openBirthDates"
                                :disabledDates="disabledBirthDates" 
                                :typeable=true
                                :language='datePickerLanguageLookup()'
                                input-class='form-control' 
                                :placeholder='$t("text.datePlaceholder")'
                                format='M/d/yyyy'
                                aria-required='true'></datepicker>
                        </div>
                    </div>
                    <div class='form-row'>
                        <div class='col-12'>
                        <span for='traveller10_dob' class='feedback' id='err_traveller10_dob' tabindex="-1"></span>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <br/>
        <div v-show='this.$store.state.oldestTraveller>=60&&this.$store.state.wantsMedical===true'>
            {{$t('text.page4_medicalquestionnaire')}}
        </div>
    </div>
</template>

<script>
import getLocale from "../utils/getLocale";
import { addNavProceedCheck, updateNavProceed } from "../utils/navProceed.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField, callValidationStatusOnBlur } from "../utils/validation.js";
import { validateBirthDate } from "../utils/validation_custom.js";

import Datepicker from "vuejs-datepicker";
import {en, fr} from "vuejs-datepicker/dist/locale";
const dateYesterday = new Date();
dateYesterday.setDate(dateYesterday.getDate() - 1);
const date15DaysAgo = new Date();
date15DaysAgo.setDate(date15DaysAgo.getDate() - 15);


export default {
  components: {
    Datepicker
  },
  data() {
    return {
      disabledTripDates: {
        to: dateYesterday
      },
      disabledBirthDates: {
        from: date15DaysAgo
      },
      province_full: this.$store.state.province_full,
    }
  },
  computed: {
    openBirthDates: {
        get(){
            const openBirthDate = new Date();
            openBirthDate.setDate(openBirthDate.getDate() - this.$store.state.oldestTraveller * 365);
            return openBirthDate;
        }
    },
    traveller1_dob: {
      get() {
        if(this.$store.state.traveller1_dob==="" && (this.$store.state.oldestTraveller_isPrimary===true||this.$store.state.numberOfTravellers===1)) {
          return this.$store.state.oldestTraveller_dob; 
        }
        else {
          return this.$store.state.traveller1_dob;
        }
      },
      set(newValue) {
        this.setDateOfBirth("traveller1_dob", newValue);
      }
    },
    traveller2_dob: {
      get() {
        if(this.$store.state.traveller2_dob==="" && this.$store.state.oldestTraveller_isPrimary===false) {
          return this.$store.state.oldestTraveller_dob; 
        }
        else {        
          return this.$store.state.traveller2_dob;
        }
      },
      set(newValue) {
        this.setDateOfBirth("traveller2_dob", newValue);
      }
    },
    traveller3_dob: {
      get() {
        return this.$store.state.traveller3_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller3_dob", newValue);
      }
    },
    traveller4_dob: {
      get() {
        return this.$store.state.traveller4_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller4_dob", newValue);
      }
    },
    traveller5_dob: {
      get() {
        return this.$store.state.traveller5_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller5_dob", newValue);
      }
    },
    traveller6_dob: {
      get() {
        return this.$store.state.traveller6_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller6_dob", newValue);
      }
    },
    traveller7_dob: {
      get() {
        return this.$store.state.traveller7_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller7_dob", newValue);
      }
    },
    traveller8_dob: {
      get() {
        return this.$store.state.traveller8_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller8_dob", newValue);
      }
    },
    traveller9_dob: {
      get() {
        return this.$store.state.traveller9_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller9_dob", newValue);
      }
    },
    traveller10_dob: {
      get() {
        return this.$store.state.traveller10_dob;
      },
      set(newValue) {
        this.setDateOfBirth("traveller10_dob", newValue);
      }
    },
  },
  methods: {
    setDateOfBirth(targetField, newValue){
      // Check if this is a valid Birth Date
      document.getElementById(targetField).classList.remove("is-invalid");
      document.getElementById(targetField).classList.add("is-valid");
      if (validateField(document.getElementById(targetField), newValue, validationRules())) {
        validateBirthDate(document.getElementById(targetField), newValue, this.$store.state.wantsMedical);
      }
      // Check if the Nav Proceed button should be updated.
      if(newValue!==""){
        if(!document.getElementById(targetField).classList.contains("is-invalid")){
          const targets = [];
          for(let i=1; i<=10;i++){
            if(i<=this.$store.state.numberOfTravellers){
              if(targetField!=="traveller"+i+"_dob"){
                targets.push(document.getElementById("traveller"+i+"_dob"));
              }
            }
          }
          updateNavProceed(targets);
        }
        else {
          document.getElementById("nav_next_enabled").classList.add("d-none");
          document.getElementById("nav_next_disabled").classList.remove("d-none");
        }
      }
      this.calculateOldestTraveller();
    },
    calculateOldestTraveller(){
      let oldestTraveller = 0;
      for(let i=1; i<=10;i++){
        if(i<=this.$store.state.numberOfTravellers) {
          const age = this.$moment(this.$store.state.departureDate,"MM/DD/YYYY").diff(this.$moment(document.getElementById("traveller"+i+"_dob").value,"MM/DD/YYYY"), "years", false);
          if(age>oldestTraveller) {
            oldestTraveller=age;
          }
        }
      }
      if(oldestTraveller>0) {
        this.$store.commit("updateOldestTraveller", oldestTraveller);
      }
    },
    swapPrimaryApplicant(){
      const temp=document.getElementById("traveller1_dob").value;
      document.getElementById("traveller1_dob").value=document.getElementById("traveller2_dob").value;
      document.getElementById("traveller2_dob").value=temp;
      if(this.$store.state.oldestTraveller_isPrimary===true){
        this.$store.state.oldestTraveller_isPrimary=false;
        this.formatOldestTraveller(false);
      } else {
        this.$store.state.oldestTraveller_isPrimary=true;        
        this.formatOldestTraveller(true);
      }

    },
    formatOldestTraveller(state=this.$store.state.oldestTraveller_isPrimary){
      if(state===true){
        document.getElementById("isPrimaryApplicant").checked=true;
        if(this.$store.state.numberOfTravellers>1){
        document.getElementById("isPrimaryApplicant").style.display="block";
        document.getElementById("lbl_isPrimaryApplicant").style.display="block";        
        }
        else {
          document.getElementById("isPrimaryApplicant").style.display="none";
          document.getElementById("lbl_isPrimaryApplicant").style.display="none";  
        }
        document.getElementById("traveller1_dob").setAttribute("disabled","disabled");
        document.getElementById("traveller2_dob").removeAttribute("disabled");
        document.getElementById("isNotPrimaryApplicant").style.display="none";
        document.getElementById("lbl_isNotPrimaryApplicant").style.display="none";
      } else {
        document.getElementById("isPrimaryApplicant").style.display="none";
        document.getElementById("lbl_isPrimaryApplicant").style.display="none";
        document.getElementById("traveller1_dob").removeAttribute("disabled");
        document.getElementById("traveller2_dob").setAttribute("disabled","disabled");
        document.getElementById("isNotPrimaryApplicant").checked=false;
        document.getElementById("isNotPrimaryApplicant").style.display="block";
        document.getElementById("lbl_isNotPrimaryApplicant").style.display="block";
      }
    },
    datePickerLanguageLookup() {
        const locale = getLocale();
        if(locale==="fr") {
          return fr;
        }
        else {
          return en;
        }
    }
  },
  mounted() {
    // Clear appended text from Quote page title;
    document.getElementById("stepTitleAppend").innerHTML="";
    
    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}

    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    // Show/hide the traveller fields depending on # selected
    const rowList = document.getElementById("travellerSection").children;
    let rowsToShow = this.$store.state.numberOfTravellers;
    if (rowsToShow === "") {
      rowsToShow = 1;
    }
    for (let x = 0; x <= 9; x++) {
      if (x < rowsToShow) {
        
        rowList[x].classList.remove("d-none");
      } else {
        rowList[x].classList.add("d-none");
      }
    }

    // Manually add ARIA-REQUIRED tag for date time inputs
    document.getElementById("traveller1_dob").setAttribute("aria-describedby","err_traveller1_dob");
    document.getElementById("traveller2_dob").setAttribute("aria-describedby","err_traveller2_dob");
    document.getElementById("traveller3_dob").setAttribute("aria-describedby","err_traveller3_dob");
    document.getElementById("traveller4_dob").setAttribute("aria-describedby","err_traveller4_dob");
    document.getElementById("traveller5_dob").setAttribute("aria-describedby","err_traveller5_dob");
    document.getElementById("traveller6_dob").setAttribute("aria-describedby","err_traveller6_dob");
    document.getElementById("traveller7_dob").setAttribute("aria-describedby","err_traveller7_dob");
    document.getElementById("traveller8_dob").setAttribute("aria-describedby","err_traveller8_dob");
    document.getElementById("traveller9_dob").setAttribute("aria-describedby","err_traveller9_dob");
    document.getElementById("traveller10_dob").setAttribute("aria-describedby","err_traveller10_dob");
    document.getElementById("traveller1_dob").setAttribute("aria-required","true");
    document.getElementById("traveller2_dob").setAttribute("aria-required","true");
    document.getElementById("traveller3_dob").setAttribute("aria-required","true");
    document.getElementById("traveller4_dob").setAttribute("aria-required","true");
    document.getElementById("traveller5_dob").setAttribute("aria-required","true");
    document.getElementById("traveller6_dob").setAttribute("aria-required","true");
    document.getElementById("traveller7_dob").setAttribute("aria-required","true");
    document.getElementById("traveller8_dob").setAttribute("aria-required","true");
    document.getElementById("traveller9_dob").setAttribute("aria-required","true");
    document.getElementById("traveller10_dob").setAttribute("aria-required","true");

    // Check if Next button should be enabled or disabled.
    const targets = [
        document.getElementById("traveller1_dob"),
        document.getElementById("traveller2_dob"),
        document.getElementById("traveller3_dob"),
        document.getElementById("traveller4_dob"),
        document.getElementById("traveller5_dob"),
        document.getElementById("traveller6_dob"),
        document.getElementById("traveller7_dob"),
        document.getElementById("traveller8_dob"),
        document.getElementById("traveller9_dob"),
        document.getElementById("traveller10_dob")
    ];
    this.$nextTick( () => {
      updateNavProceed(targets);
      this.formatOldestTraveller();
      this.calculateOldestTraveller();
    });
  },
}
</script>